

import { Directive, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../../app.reducer';
import { getAplicacionesUsuarioPorAmbiente } from '../../redux/usuario/usuario.selectors';
import { Aplicacion } from '../../models/usuario.model';
import { Permiso } from './../../modulos/admin/models/permiso';

@Directive({
  selector: '[hasPermission]'
})
export class HasPermissionDirective implements OnInit {

  public _app: number;
  public _permission: [];
  aplicaciones: Aplicacion[];

  @Input() set hasPermission(value: any) {

    this._app = value.app;
    this._permission = value.permission;
  }

  constructor(
    private store: Store<AppState>,
    private viewContainerRef: ViewContainerRef,
    private templateRef: TemplateRef<any>
  ) { }


  ngOnInit(): void { 

    let renderComponent = false;
    this.store.select(getAplicacionesUsuarioPorAmbiente).subscribe((response) => {
      this.aplicaciones = response
    })

    let aplicacionAct = this.aplicaciones.find(({idSprAplicacion})=>idSprAplicacion===this._app)

    if(aplicacionAct){
      for (let permiso of aplicacionAct.permisos) {
        if (this._permission.find((per)=>per===permiso.idSprPermiso)) {
          renderComponent = true;
          break;
        }
      }
    }else{
      80/0
      renderComponent = false;
    }

    if (renderComponent) {
      this.viewContainerRef.createEmbeddedView(this.templateRef)
    } else {
      this.viewContainerRef.clear();
    }
  }
}
